import styled from "styled-components";
import {CFlexBetween, DText, FlexBetween} from "../../../styles/CommonStyles";
import { FaExchangeAlt, FaChartLine, FaColumns} from "react-icons/fa";
import Text from "../../../utils/Text";
import {useEffect, useState} from "react";
import {HOME} from "../../../constants/urls";
import { GiCardExchange } from "react-icons/gi"


const BottomBar = () => {

    const [active, setActive] = useState(-1)

    useEffect(() => {
        const pathname = window.location.pathname
        if (pathname?.includes("trade")) {
            setActive(3)
        }
    }, [])

    return (
        <Body>
            <FlexBetween>
                {tabs.map((tab, idx) => (
                    <a href={tab.href} key={tab.name}>
                        <CFlexBetween>
                            <tab.icon size={18} active={idx === active} />
                            <DText fontSize={'0.775rem'} style={{ letterSpacing: '0', fontWeight: 500 }} color={active === idx && "#2697ff"}><Text tid={tab.name} /></DText>
                        </CFlexBetween>
                    </a>
                ))}
            </FlexBetween>
        </Body>
    )
}


const DashboardIcon = styled(FaColumns)`
  color: ${(props) => (props.active ? 'rgb(39, 163, 220)' : props.theme.color)};
`
const MarketsIcon = styled(FaChartLine)`
  color: ${(props) => (props.active ? 'rgb(39, 163, 220)' : props.theme.color)};
`
const OtcIcon = styled(FaExchangeAlt)`
  color: ${(props) => (props.active ? 'rgb(39, 163, 220)' : props.theme.color)};
`
const WalletIcon = styled(GiCardExchange)`
  color: ${(props) => (props.active ? 'rgb(39, 163, 220)' : props.theme.color)};
`

const tabs = [
    { name: 'home-page', icon: DashboardIcon, href: HOME },
    { name: 'otc-trade', icon: OtcIcon, href: HOME + 'otc2/form' },
    { name: 'markets', icon: MarketsIcon, href: HOME + 'market' },
    { name: 'p2p-trade', icon: WalletIcon, href: HOME + 'trade/BTC_IRT' },
]
const Body = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 60px;
  direction: ${props => props.theme.english ? "ltr" : "rtl"};
  background-color: ${props => props.theme.secondaryBg};
  box-shadow: -2px 0 4px ${props => props.theme.mainBg};
  padding: 10px 20px;
  z-index: 100;
`


export default BottomBar;
